export default __webpack_public_path__ + "static/media/compcoreDark.2d0fbc37.png";